export default __webpack_public_path__ + "static/char-03-anr-2e1815504ff97a2d3f99d55cec9bf569.webp";